import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

export default () => {
    const {
        response: { query },
    } = useAppState()

    useEffect(() => {
        nostojs(function (api) {
            var request = api.createRecommendationRequest()
            request.addElements(['nosto-no-results-serp'])
            request.loadRecommendations()
        })
        jQuery('html, body').removeClass('noscroll')
    })

    useEffect(() => {
        const headerSearchButton = document.querySelector('.header__close-search')
        const searchHeader = document.querySelector('.header__search')

        if (query.length > 0) {
            if (headerSearchButton && searchHeader.classList.contains('active--search')) {
                headerSearchButton.click()
            }
        }
    }, [query])

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            <div class="ns-font-4">No results found for '{query}'</div>
            <div class="nosto_element" id="nosto-no-results-serp" style="margin-top: 40px;"></div>
        </div>
    )
}
